/* WF v29 (19.10.2026): Produktgalerie bleibt beim Laden stehen.
   1) Shopify.Image.switchImage ersetzt: beim ersten Aufruf nur springen (ohne Animation), wenn der Link
      selbst ?variant= hatte (z. B. Google Shopping). Sonst bleibt Bild 1 stehen.
   2) Solange der Kunde die Seite noch nicht berührt hat, ignoriert die Galerie automatische Sprünge.
   WF v31 (19.10.2026): Bilder ab Nr. 2 werden erst geladen, wenn sie gebraucht werden.
   Im Theme (sections/template-product.liquid) haben diese Bilder nur ein kleines Vorschaubild (_100x)
   als src und die echten Größen in data-wf-src / data-srcset. Hier werden sie rechtzeitig getauscht:
   - sofort: aktives Bild + 2 Nachbarn,
   - bei jedem Bildwechsel: wieder aktives + 2 Nachbarn,
   - sobald der Kunde die Galerie berührt: die nächsten 4,
   - Desktop (ab 768 px): nach dem Laden der Seite im Leerlauf alle (Thumbnail-Klicks sofort scharf).
   Das kleine Vorschaubild wird nie gezeigt (unsichtbar); das scharfe Bild wird erst sichtbar, wenn es
   fertig geladen ist -> kein Unscharf-Effekt. Lupe/Zoom nutzt die größte Version aus data-srcset. */
(function () {
  'use strict';
  if (!document.querySelector || location.pathname.indexOf('/products/') === -1) return;
  try {
    var st = document.createElement('style');
    st.id = 'wf-gallery-lazy-css';
    st.appendChild(document.createTextNode('.gallery_big .swiper-slide img[data-srcset],.gallery_big .swiper-slide img.wf-loading{visibility:hidden}'));
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
  var first = true;
  var touched = false;
  ['pointerdown', 'touchstart', 'mousedown', 'keydown', 'click'].forEach(function (ev) {
    window.addEventListener(ev, function () { touched = true; }, { capture: true, passive: true });
  });
  function fname(u) {
    if (!u) return '';
    u = String(u).split('?')[0];
    u = u.substring(u.lastIndexOf('/') + 1);
    return u.replace(/_(\d+x\d*|\d*x\d+)(_crop_[a-z]+)?(@\dx)?(?=\.[a-z]+$)/i, '').toLowerCase();
  }

  /* ---------- Bilder nachladen ---------- */
  function upImg(img) {
    if (!img) return;
    var ss = img.getAttribute('data-srcset');
    if (!ss) return;
    var s = img.getAttribute('data-wf-src');
    img.classList.add('wf-loading');
    var shown = false;
    var show = function () { if (shown) return; shown = true; img.classList.remove('wf-loading'); };
    img.addEventListener('load', function () {
      if (img.currentSrc && /_100x\./.test(img.currentSrc)) return;
      show();
    });
    img.addEventListener('error', show);
    setTimeout(show, 8000);
    img.removeAttribute('loading');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-wf-src');
    img.setAttribute('srcset', ss);
    if (s) img.setAttribute('src', s);
  }
  function slidesOf(gb) {
    return gb ? gb.querySelectorAll('.swiper-wrapper > .swiper-slide') : [];
  }
  function upAround(gb, idx, before, after) {
    var sl = slidesOf(gb);
    for (var i = idx - before; i <= idx + after; i++) {
      if (i >= 0 && i < sl.length) upImg(sl[i].querySelector('img'));
    }
  }
  function activeIdx(gb) {
    if (gb && gb.swiper && typeof gb.swiper.activeIndex === 'number') return gb.swiper.activeIndex;
    var sl = slidesOf(gb);
    for (var i = 0; i < sl.length; i++) if (sl[i].classList.contains('swiper-slide-active')) return i;
    return 0;
  }
  function upAll(gb) {
    var sl = slidesOf(gb);
    for (var i = 0; i < sl.length; i++) upImg(sl[i].querySelector('img'));
  }
  function lazyInit() {
    var gb = document.querySelector('.gallery_big');
    if (!gb || gb.__wfLazy) return;
    gb.__wfLazy = true;
    upAround(gb, activeIdx(gb), 1, 2);
    var mo = new MutationObserver(function () { upAround(gb, activeIdx(gb), 2, 2); });
    var sl = slidesOf(gb);
    for (var i = 0; i < sl.length; i++) mo.observe(sl[i], { attributes: true, attributeFilter: ['class'] });
    var warm = function () { upAround(gb, activeIdx(gb), 2, 4); };
    gb.addEventListener('touchstart', warm, { passive: true });
    gb.addEventListener('pointerdown', warm, { passive: true });
    gb.addEventListener('mouseenter', warm);
    var strip = function () {
      var st = document.querySelector('.wf-thumbstrip');
      if (st && !st.__wfLazy) { st.__wfLazy = true; st.addEventListener('mouseenter', function () { upAll(gb); }); }
    };
    strip(); setTimeout(strip, 1500);
    var desk = function () {
      if (window.innerWidth < 768) return;
      var go = function () { upAll(gb); };
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 1500);
    };
    if (document.readyState === 'complete') desk(); else window.addEventListener('load', desk);
  }

  function guard(sw) {
    if (!sw || sw.__wfGuard) return;
    sw.__wfGuard = true;
    var orig = sw.slideTo;
    sw.slideTo = function (index) {
      if (!touched && typeof index === 'number' && index !== sw.activeIndex) return false;
      if (typeof index === 'number') upAround(document.querySelector('.gallery_big'), index, 1, 1);
      return orig.apply(sw, arguments);
    };
  }
  function wfSwitchImage(newImage, element, cb) {
    var gb = document.querySelector('.gallery_big');
    var sw = gb && gb.swiper;
    var src = newImage && (newImage.src || newImage);
    var isFirst = first;
    first = false;
    if (!sw || !src) return;
    var target = fname(src), idx = -1;
    for (var i = 0; i < sw.slides.length; i++) {
      var el = sw.slides[i];
      var img = el && el.querySelector ? el.querySelector('img') : null;
      if (img && fname(img.getAttribute('src')) === target) { idx = i; break; }
    }
    if (isFirst) {
      if (idx > -1 && idx !== sw.activeIndex && window.__wfVarUrl) {
        upAround(gb, idx, 1, 1);
        var ok = touched; touched = true; sw.slideTo(idx, 0); touched = ok;
      }
      guard(sw);
      lazyInit();
      return;
    }
    guard(sw);
    if (idx > -1 && idx !== sw.activeIndex) sw.slideTo(idx, 300);
  }
  function patch(img) {
    if (img && typeof img === 'object' && img.switchImage !== wfSwitchImage) img.switchImage = wfSwitchImage;
    return img;
  }
  var S = window.Shopify = window.Shopify || {};
  if (S.Image) { patch(S.Image); }
  else {
    var stored;
    try {
      Object.defineProperty(S, 'Image', {
        configurable: true,
        enumerable: true,
        get: function () { return stored; },
        set: function (v) { stored = patch(v); }
      });
    } catch (e) {
      document.addEventListener('DOMContentLoaded', function () { patch(S.Image); });
    }
  }
  /* Fallback: Galerie absichern und Nachladen starten, auch falls switchImage nie aufgerufen wird */
  var tries = 0;
  (function poll() {
    var gb = document.querySelector('.gallery_big');
    if (gb && gb.swiper) { guard(gb.swiper); lazyInit(); return; }
    if (++tries < 100) setTimeout(poll, 50);
    else if (gb) lazyInit();
  })();
  /* Ganz ohne Swiper (Fehlerfall): nach dem Laden alles normal laden */
  window.addEventListener('load', function () {
    setTimeout(function () {
      var gb = document.querySelector('.gallery_big');
      if (gb && !gb.swiper) upAll(gb);
    }, 3000);
  });
})();
